import { Typography } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { useStats } from 'react-instantsearch'
import { isNotNullOrUndefined } from 'helpers/array'

export default function Stats() {
  const { t } = useTranslation('common')
  const { query, nbHits } = useStats()
  const results = nbHits > 100 ? t('eventListing.more_than_100') : nbHits
  const stats = [
    nbHits > 0 ? results : t('eventListing.no_results'),
    t('STATS', { count: nbHits }),
    query.length > 0 ? `${t('eventListing.for')} "${query}"` : null
  ]
    .filter(isNotNullOrUndefined)
    .join(' ')
  return <Typography variant="h2">{stats}</Typography>
}
